import { Venue } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

const venueListVenuesQuery = /* GraphQL */ `
  query VenueListVenues($input: VenueListVenuesRequest!) {
    venueListVenues(input: $input) {
      items {
        id
        name
        picture {
          thumbnail
        }
        totalActiveOffers
        masterVenueID
      }
    }
  }
`;

export const venueListVenuesApi = async (masterVenueID: string): Promise<Venue[]> => {
  const result = await executeGql(venueListVenuesQuery, {
    input: { venueID: Number(masterVenueID) },
  });
  return processGqlResult<Venue[]>('venueListVenues.items', result);
};
